import "./home.scss"
import ParticlesBg from "particles-bg"
import svgHero from "../Home/wave.svg"
import styled from "styled-components"
import {BsChevronCompactDown} from "react-icons/bs"
import { init } from "ityped"
import { useEffect, useRef } from "react";

const Waves = styled.div`
    z-index: 1;
    bottom: -1px;
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: url(${svgHero});
    background-repeat: no-repeat;
    background-position: bottom;
`



export default function Home() {
    const textRef = useRef();

    useEffect(() => {
        init(textRef.current, {
        showCursor: true,
        backDelay: 1200,
        startDelay: 300,
        backSpeed:60,
        strings: ["CS undergraduate.","Developer.", "Designer.", "Writer."],
        });
    }, []);

    return (
        <div className="home" id="home">
            <div className="homeIntro">
                <div className="wrapper">
                    <h2>Hey there! I'm</h2>
                    <h1>Adheena B</h1>
                    <h3>A <span ref={textRef}></span></h3>
                </div>
                <a href="#about"><BsChevronCompactDown color="white" fontSize="3em"/></a>
            </div>
            <Waves/>
            <ParticlesBg num={25} color="" type="cobweb" bg={{
                position: "absolute",
                zIndex: 0
            }}/>
        </div>
    )
}
